import { Outlet, useLocation } from 'react-router-dom';
import Layout from '../components/ui/Layout';
import CreateAction from '../components/operational/createAction';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';
import { useNavigate } from 'react-router-dom';
import myAppsSlice from '../redux/myAppsSlice';
import { license } from '../data/license';
import { Surveys } from '../pages/DashboardPages/Surveys/Surveys';
import SurveyManager from '../pages/DashboardPages/Surveys/SurveyManager';

function Survey() {
    const [isSurveysChecked, setIsSurveysChecked] = useState(false);
    const [activeSurveys, setActiveSurveys] = useState(null)
    const [redirectUrl, setRedirectUrl] = useState("")
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const checkSurvey = async () => {

        const response = await CreateAction({
            method: 'get',
            path: '/survey',
            showPreLoader: true,
            isFileUploading: false,
            hideToastMessages: true
        });
        const surveys = response?.result?.resultData
        if (surveys?.length > 0) {
            const filteredSurveys = surveys.filter((survey) => Surveys[survey?.type])
            setActiveSurveys(filteredSurveys)
        }
        setIsSurveysChecked(true)
        setRedirectUrl(window.location.pathname)

    };



    useEffect(() => {
        checkSurvey();
    }, []);

    useEffect(() => {
        if (activeSurveys?.length === 0 && isSurveysChecked && redirectUrl && !redirectUrl?.includes("/surveys")) {
            window.history.replaceState({}, "", redirectUrl);
        }
    }, [activeSurveys])

    return (
        <>
            {
                isSurveysChecked &&
                <>
                    {activeSurveys?.length > 0 ? <SurveyManager activeSurveys={activeSurveys} setActiveSurveys={setActiveSurveys} ></SurveyManager> :
                        <Outlet></Outlet>
                    }

                </>
            }
        </>
    );
}

export default Survey;
